import { Injectable } from '@angular/core';
import { AsyncValidator, ValidationErrors, FormControl } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { PhraseTypeSettingsService } from 'src/core/services/settings/phrase-type-settings.service';

@Injectable({ providedIn: 'root' })
export class PhraseTypeRegexDetailPatternValidator implements AsyncValidator {
  tempObservable: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(private service: PhraseTypeSettingsService) {}

  validate(
    formControl: FormControl
  ): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    const value = formControl.value;

    if (value) {
      return this.service.checkRegexDetailSyntaxValid(value).pipe(
        map(
          response => {
            return response !== null && response.length > 0
              ? { regexSyntaxInvalidPattern: { message: response } }
              : null;
          },
          catchError(() => {
            return null;
          })
        )
      );
    }

    return this.tempObservable.pipe(
      map(() => {
        return null;
      })
    );
  }
}
